export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-50/70">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <h4 className="text-base font-heading font-bold text-background-50 mb-4">被窝网电影</h4>
            <p className="text-xs leading-relaxed text-background-50/60 mb-4">
              大全高清免费在线观看平台。海量影视资源聚合，最新电影电视剧全集不缓冲流畅播放，尽享舒适观影体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-home-line text-sm"></i>
              </a>
              <a href="#ranking" className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-fire-line text-sm"></i>
              </a>
              <a href="#carousel" className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-star-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2">
              <a href="#cards" className="block text-xs text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">高清资源大全</a>
              <a href="#ranking" className="block text-xs text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">热播榜单</a>
              <a href="#carousel" className="block text-xs text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">精选专题</a>
              <a href="#index" className="block text-xs text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">分类索引</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">帮助中心</h4>
            <div className="space-y-2">
              <a href="#faq" className="block text-xs text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">常见问题</a>
              <a href="#contact" className="block text-xs text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</a>
              <a href="#about" className="block text-xs text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</a>
              <a href="#features" className="block text-xs text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">平台优势</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-50/40 leading-relaxed">
              期待与更多优质平台建立合作关系，共同为影迷提供更好的观影服务。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; 2026 被窝网电影大全 · 高清免费在线观看 · 不缓冲流畅播放
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span className="whitespace-nowrap">安全观影</span>
            <span className="whitespace-nowrap">无广告纯净体验</span>
            <span className="whitespace-nowrap">全端适配</span>
          </div>
        </div>
      </div>
    </footer>
  );
}